/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
], function () {
	'use strict';
	const DashboardSettingsUtils = class DashboardSettingsUtils {
		/** 
		 * @param {Array} an array of features
		 * @description features array will be sorted in place by profiles
		 */
		static sortFeaturesByProfiles(featuresCollection) {
			featuresCollection.sort(DashboardSettingsUtils._featureProfileComparator);
		}

		/** 
		 * @private
		 * @description Compare the feature by its profiles field. In ascending order,
		 * the comparator weight for profile 'core', 'consume' and 'authoring', 'no profile' 
		 * as well as 'unexpected profile' are respectively 1,2,3 and 0
		 */
		static _featureProfileComparator(featureA, featureB) {
			const fnGetProfileOrder = (profiles) => {
				if (profiles && profiles.length) {
					if (profiles.indexOf('core') >= 0) {
						return 1;
					} else if (profiles.indexOf('consume') >= 0) {
						return 2;
					} else if (profiles.indexOf('authoring') >= 0) {
						return 3;
					} else {
						return 0;
					}
				} else {
					return 0;
				}
			};
			return fnGetProfileOrder(featureA.profiles) - fnGetProfileOrder(featureB.profiles);
		}
	};
	return DashboardSettingsUtils;
});